import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loadGenerateAnswer } from '../thunks/answersGeneration.thunk';
import { IGenerateAnswerState } from './types';

const initialState: IGenerateAnswerState = {
  query: '',
  error: null,
  isLoading: false,
  answer: null,
  usedArticles: [],
  isProhibited: false,
};

export const generateAnswerSlice = createSlice({
  name: 'generateAnswer',
  initialState,
  reducers: {
    resetGenerateAnswer: (state, action: PayloadAction<string>) => ({
      ...initialState,
      query: action.payload || '',
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadGenerateAnswer.pending, (state, action) => {
      return {
        ...state,
        query: action.meta.arg.query,
        error: null,
        isLoading: true,
      };
    });

    builder.addCase(loadGenerateAnswer.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        query: action.payload.term || action.payload.query,
        isProhibited: action.payload.isProhibited,
        answer: action.payload.answer,
        usedArticles: action.payload.usedArticles,
      };
    });

    builder.addCase(loadGenerateAnswer.rejected, (state, action) => {
      return {
        ...state,
        error: action.error as string,
        isLoading: false,
        answer: '',
      };
    });
  },
});
